import React from 'react';

const Lives = ({ dead }) => {
    if (dead) {
        return  <img src="./img/game_icons/track-the-ball/heart-dead.svg" alt=""/>
    } else {
        return <img src="./img/game_icons/track-the-ball/heart.svg" alt=""/>
    }
};

export default Lives;
